import $ from 'jquery';
import 'slick-carousel';

const slider = () => {
  const element = $('.js-slider');

  if (element.length) {
    element.slick({
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      lazyLoad: true,
      prevArrow:
        '<button type="button" class="slick-prev c-slider__arrow c-slider__arrow--prev"></button>',
      nextArrow:
        '<button type="button" class="slick-next c-slider__arrow c-slider__arrow--next"></button>',
    });
  }

  const elementItems = $('.js-slider-items');

  if (elementItems.length) {
    elementItems.slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      infinite: false,
      lazyLoad: true,
      prevArrow:
        '<button type="button" class="slick-prev c-slider-items__arrow c-slider-items__arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14"><g><g><path fill="none" stroke="#107b85" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M7.194 13.612v0l-6.25-6.25v0l6.25-6.25v0"/></g></g></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next c-slider-items__arrow c-slider-items__arrow--next"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14"><g><g><path fill="none" stroke="#107b85" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M7.194 13.612v0l-6.25-6.25v0l6.25-6.25v0"/></g></g></svg></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
};
export default slider;



// WEBPACK FOOTER //
// ./src/scripts/modules/slider.js